export type Color = string;

export const lightmodecolors = {
  White: 'rgba(255, 255, 255, 1)',
  Black: '#000000',
  Grey: '#666666',
  Primary1: 'rgba(69, 110, 255, 1)',
  Primary2: 'rgba(39, 83, 239, 1)',
  Primary3: 'rgba(26, 68, 220, 1)',
  Primary4: '#000D3D',
  Primary5: 'rgba(0, 13, 61, 1)',
  Secondary1: 'rgba(211, 218, 249, 1)',
  Secondary2: '#000182',
  Secondary3: '#000182',
  Secondary4: '#000182',
  Secondary5: '',
  Secondary6: '',
  Secondary7: '',
  Secondary8: '',
  Text1: 'rgba(0, 13, 61, 1)',
  Text2: 'rgba(0, 1, 130, 1)',
  Text3: 'rgba(69, 110, 255, 1)',
  Text4: 'rgba(47, 51, 63, 1))',
  Text5: '#4F5463',
  Text6: 'rgba(149, 153, 169, 1)',
  Text7: '#BAC1DD',
  Text8: '#FFFFFF',
  Text9: 'rgba(255, 131, 131, 1)',
  Grey1: '#F8F9FF',
  Grey2: '#EEF1FE',
  Grey3: '#E0E4F4',
  Grey4: '#D3DAF9',
  Grey5: '#9599A9',
  Grey6: '#4F5463',
  Grey7: '#2F333F',
  Grey8: '',
  Grey9: '',
  Positive: 'rgba(0, 184, 132, 1)',
  Positive20: 'rgba(0, 184, 132, 0.2)',
  Positive20Flat: '#CDFEE6',
  Negative: 'rgba(255, 131, 131, 1)',
  Negative20: 'rgba(255, 131, 131, 0.2)',
  Negative20Flat: '#FFD8D8',
  NegativeTint: 'rgba(255, 131, 131, 0.2)',
  Neautral: 'rgba(255, 168, 0, 1)',
  Neautral20: 'rgba(255, 168, 0, 0.2)',
  Neautral20Flat: '#FFF5D6',
  Tint1: 'rgba(64, 65, 161, 1)',
  Tint2: 'rgba(69, 110, 255, 0.2)',
  Tint3: 'rgba(0, 1, 79, 1)',
  Tint4: 'rgba(0, 1, 79, 0.1)',
  Tint5: 'rgba(255, 255, 255, 0.2)',
  PositiveTint8: 'rgba(0, 184, 132, 0.08)',
  Quarternary: 'rgba(39, 83, 239, 0.2)',
  ModalOverlay: 'rgba(0, 13, 61, 0.7)',
  Gradient: {
    linear: 'linear(to-l, #A327EF , #2753EF)'
  }
};
